/**
 *    @author:
 *    @since:
 *
 */

 import { Component, AfterViewInit, ViewChild,OnInit } from '@angular/core';
 import { Router } from '@angular/router'; 
 import { TimerService } from 'src/refresh/service/timer-service';
 import { FormBaseComponent } from '../_common/component/form-base.component';
 import { InputData } from '../_common/data/input-data';
 import { Path, Progress } from  "../_common/constant/page-const";
 import { Setup2Validation } from './setup_2.validator';
 import { ItemList } from '../_common/constant/item-list';
 import { ChildDeceasedComponent } from './child-deceased/child-deceased.component';
import { ProgressService } from 'src/refresh/service/progress-service';
import { Confirm } from 'src/refresh/service/constant';
import { ViewportScroller } from '@angular/common';
 
 @Component({ 
       selector: 'setup_2',
       templateUrl: './setup_2.component.html',
       styleUrls: ['./setup_2.component.less']
 })
 export class Setup2Component extends FormBaseComponent implements AfterViewInit,OnInit  {
 
      orgContactPath = Path.ORGContactInformation;
      public error_isChildDeceased: string;
      public error_isUnableToCertify: string;

      private isChildDeceased:boolean;  // backup for change

      @ViewChild(ChildDeceasedComponent) childDeceased:ChildDeceasedComponent;
       
      constructor( protected router: Router ,
                   public timerService:TimerService,
                   protected progress:ProgressService,
                   public data:InputData,  
                   public items:ItemList,
                   public viewportScroller: ViewportScroller) {

            super(router,timerService);  
            super.setNextPage(Path.Setup3,Path.Setup1);

            this.isChildDeceased = this.data.aboutChild.isChildDeceased == Confirm.YES;

            InputData.currentPageIdx = 4;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }
 
      ngOnInit() {
      	 super.forwardNext(this.data.eligibility.listedParentCount);
      }

      public ngAfterViewInit() {
            super.ngAfterViewInit();
            super.setValidator(new Setup2Validation(this,this.childDeceased,Progress.Eligibility));    
      }
 
       
      hideCancelBtn(){
            if(this.data.aboutChild.isChildDeceased === 'Y' || this.data.eligibility.isUnableToCertify === 'Y'){
                  return false;
            } 

            return true;
      }

       public  onCancelApplication() {
               super.cancelApplication(this.data);
       }

       public onNextClick() : boolean {
              this.productRemove();
              return super.onNextClick();
       }

       public onPreviousClick() {
            this.productRemove();
            super.onPreviousClick();
       }

       private productRemove() {

            if ( this.isChildDeceased == (this.data.aboutChild.isChildDeceased == Confirm.YES) ) return;
            this.progress.adjustBundles(this.data);
      }
 }
 